import React from "react";

export default function CostumButton(props){
    return(
        <button className={props.class} src={props.src}>Follow me on Instagram</button>
    )
}